<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1CDWZkN/tc-custom/9780253026552.jpg?1737783038168" alt="This image is the cover for the book Cosmopolitan Film Cultures in Latin America, 1896–1960, New Directions in National Cinemas"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Cosmopolitan Film Cultures in Latin America, 1896–1960, New Directions in National Cinemas
      </h1>
      <p class="bookDescription body article font2">
        <p>Cosmopolitan Film Cultures in Latin America examines how cinema forged cultural connections between Latin American publics and film-exporting nations in the first half of the twentieth century. Predating today's transnational media industries by several decades, these connections were defined by active economic and cultural exchanges, as well as longstanding inequalities in political power and cultural capital. The essays explore the arrival and expansion of cinema throughout the region, from the first screenings of the Lumière Cinématographe in 1896 to the emergence of new forms of cinephilia and cult spectatorship in the 1940s and beyond. Examining these transnational exchanges through the lens of the cosmopolitan, which emphasizes the ethical and political dimensions of cultural consumption, illuminates the role played by moving images in negotiating between the local, national, and global, and between the popular and the elite in twentieth-century Latin America. In addition, primary historical documents provide vivid accounts of Latin American film critics, movie audiences, and film industry workers' experiences with moving images produced elsewhere, encounters that were deeply rooted in the local context, yet also opened out onto global horizons.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Rielle Navitski, Nicolas Poppe
      </h2>
      
      <p class="authorDescription body article"><P>Rielle Navitski is Assistant Professor of Film Studies at the University of Georgia. She is author of Public Spectacles of Violence: Sensational Cinema and Journalism in Early Twentieth-Century Mexico and Brazil.</P><P>Nicolas Poppe is Assistant Professor of Spanish at Middlebury College. His work on Latin American cinema and cultural studies has appeared in several edited volumes and journals.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Indiana University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?9ef18eb6